/** Uploaded illustrations are resized locally before transfer; no metadata or
 * external URL is sent. The server independently validates the resulting file. */
export async function prepareStoryboardImage(file: File): Promise<File> {
  if (!['image/png','image/jpeg','image/webp'].includes(file.type)) throw new Error('请选择 PNG、JPG 或 WebP 图片。')
  if (!file.size || file.size > 10 * 1024 * 1024) throw new Error('图片大小不能超过 10MB。')
  const url = URL.createObjectURL(file)
  try {
    const image = new Image()
    await new Promise<void>((resolve,reject) => {image.onload = () => resolve(); image.onerror = () => reject(new Error('这张图片无法读取，请换一张图片。')); image.src = url})
    if (!image.naturalWidth || !image.naturalHeight || image.naturalWidth * image.naturalHeight > 50_000_000) throw new Error('图片像素过大，请缩小后上传。')
    const scale = Math.min(1, 1600 / Math.max(image.naturalWidth,image.naturalHeight))
    const canvas = document.createElement('canvas'); canvas.width = Math.max(1,Math.round(image.naturalWidth*scale)); canvas.height = Math.max(1,Math.round(image.naturalHeight*scale))
    const context = canvas.getContext('2d')
    if (!context) throw new Error('当前浏览器无法处理图片，请换用较新的浏览器。')
    context.fillStyle = '#fff'; context.fillRect(0,0,canvas.width,canvas.height); context.drawImage(image,0,0,canvas.width,canvas.height)
    const encode = (mime: string,quality?: number) => new Promise<Blob>((resolve,reject) => canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('图片处理失败。')),mime,quality))
    let blob = await encode(file.type === 'image/png' ? 'image/png' : 'image/jpeg',.88)
    if (blob.size > 1_700_000) blob = await encode('image/jpeg',.76)
    if (blob.size > 1_700_000) throw new Error('图片压缩后仍过大，请缩小后上传。')
    const name = file.name.replace(/\.[^.]*$/, '').slice(0,100) || '分镜示意图'
    return new File([blob], `${name}.${blob.type === 'image/png' ? 'png' : 'jpg'}`, {type:blob.type})
  } finally {URL.revokeObjectURL(url)}
}
